import { render, staticRenderFns } from "./details.vue?vue&type=template&id=4ea9ba6e&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=4ea9ba6e&prod&scoped=true&lang=css"
import style1 from "./details.vue?vue&type=style&index=1&id=4ea9ba6e&prod&lang=scss"
import style2 from "./details.vue?vue&type=style&index=2&id=4ea9ba6e&prod&scoped=true&lang=css"
import style3 from "./details.vue?vue&type=style&index=3&id=4ea9ba6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea9ba6e",
  null
  
)

export default component.exports